const commercial = {
  commercial: {
    contactUsMessage: undefined,
    contactUsEmail: 'E-mail',
    contactUsPhone: 'Telefone',
    contactUsHelpText: undefined,
    contactUsRedirectText: 'Clique aqui',
    bomFormTitle: undefined,
    bomFormText: undefined,
    bomFormNewBomOption: undefined,
    bomFormExistingBomOption: undefined,
    leadCardTitle: 'Meus Leads',
    leadCardDesc: undefined,
    leadCardHoverDesc: undefined,
    systemCardTitle: 'Sistemas',
    systemCardDesc: undefined,
    bomCardTitle: undefined,
    bomCardDesc: undefined,
    solargrafCardTitle: undefined,
    solargrafCardDesc: undefined,
    resourceCardTitle: undefined,
    resourceCardDesc: undefined,
    commResourceTitle: undefined,
    commResourceDesc: undefined,
    euResourceTitle: undefined,
    euResourceDesc: undefined,
    serviceCardTitle: undefined,
    serviceCardDesc: undefined,
    drsServiceTitle: undefined,
    drsServiceDesc: undefined,
    permitServiceTitle: undefined,
    permitServiceDesc: undefined,
    contactCardTitle: undefined,
    contactCardDesc: undefined
  }
};
export default commercial;
